import { getFragmentData } from '@e-socna/data-layer';

import { DocumentEditorCmp_VirtualRoot_Section_Fragment } from '../queries/one-template-dependency.query';
import type { DocumentEditorCmp_TemplateDependency } from '../queries/one-template-dependency.query';

export const getVirtualRoot = (
  dependency: DocumentEditorCmp_TemplateDependency,
) => {
  const rawVirtualRoot = (() => {
    switch (dependency.__typename) {
      case 'DocumentTemplate':
        return dependency.document.virtualRoot;
      case 'SectionTemplate':
        return dependency.virtualRoot;
      default:
        throw new Error('Unsupported template type');
    }
  })();

  const virtualRoot = getFragmentData(
    DocumentEditorCmp_VirtualRoot_Section_Fragment,
    rawVirtualRoot,
  );

  return virtualRoot;
};
